import React, {Key} from "react";
import {Tree, TreeSelect} from "antd";
import {DataNode} from "antd/lib/tree";
import {AuthGroup} from "../../domains/auth-group";
import {request} from "../../utils/utils";

interface AuthGroupTreeProps {
    onTreeNodeSelect?: (key: string[]) => void,
    treeSelect?: boolean,
    treeCheckable?: boolean,
}

interface AuthGroupTreeState {
    treeData: DataNode[],
    selectedValue: string[]
}

export default class AuthGroupTree extends React.Component<AuthGroupTreeProps, AuthGroupTreeState> {

    constructor(props: Readonly<AuthGroupTreeProps> | AuthGroupTreeProps) {
        super(props);
        this.state = {treeData: [], selectedValue: []}
        let initData: DataNode[] = [{
            title: "root",
            key: "root",
            children: []
        }]
        this.getData("root").then((res: any) => {
            res.value.forEach((it: AuthGroup) => {
                initData[0].children!.push({
                    title: it.name,
                    key: it.id
                })
            })
            this.setState({treeData: initData})
        })
    }

    updateTreeIds(ids: string[]) {
        this.setState({
            selectedValue: ids
        })
    }

    private onLoadData = ({key, children}: any) => {
        return new Promise<void>(resolve => {
            if (!children) {
                resolve();
                return;
            }
            const promise: any[] = []
            children.forEach((x: DataNode) => {
                    promise.push(this.getData(x.key.toString()))
                }
            )
            Promise.all(promise).then(res => {
                res.forEach(item => {
                    this.setState((origin, props) => {
                        return {
                            treeData: this.updateTreeData(origin.treeData, item.id, item.value.map((it: AuthGroup) => {
                                return {
                                    title: it.name,
                                    key: it.id,
                                    isLeaf: it.childrenIds || 0
                                }
                            }))
                        }
                    })
                })
                resolve()
            })
        });
    }

    private getData = (id: String) => {
        return new Promise(resolve => {
            request({
                url: "/gateway/authgroup/getbyparent",
                method: "GET",
                params: {id: id}
            }).then((res) => {
                    if (res === null) {
                        resolve(undefined)
                    } else {
                        resolve({
                            id: id,
                            value: res.data
                        })
                    }
                }
            )
        })
    }

    private updateTreeData = (list: DataNode[], key: React.Key, children: DataNode[]): DataNode[] => {
        return list.map(node => {
            if (node.key === key) {
                return {
                    ...node,
                    children,
                };
            }
            if (node.children) {
                return {
                    ...node,
                    children: this.updateTreeData(node.children, key, children),
                };
            }
            return node;
        });
    }

    private onTreeNodeSelect = (key: Key[]) => {
        if (this.props.onTreeNodeSelect)
            this.props.onTreeNodeSelect(key.map((it: Key) => {
                return it.toString()
            }))
    }

    private onTreeSelectValueChange = (value: string[]) => {
        this.setState({selectedValue: value})
    }

    render() {
        return (
            <>
                <div style={{display: this.props.treeSelect ? "inherit" : "none"}}>
                    <TreeSelect treeData={this.state.treeData}
                                loadData={this.onLoadData} multiple
                                onChange={this.onTreeSelectValueChange}
                                value={this.state.selectedValue}
                                treeCheckable={this.props.treeCheckable}
                    />
                </div>
                <div style={{display: this.props.treeSelect ? "none" : "inherit"}}>
                    <Tree loadData={this.onLoadData} treeData={this.state.treeData} onSelect={this.onTreeNodeSelect}
                          checkable={this.props.treeCheckable}/>
                </div>
            </>
        )
    }

}
